<template>
  <h1>pageone</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>